// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type {
    GetIntelligentPartnerHomePageAdminTaskTrendQuery,
    BaseResponseListIntelligentPartnerHomePageAdminTaskTrend,
} from '../../../../types';

/**
 * 管理员端任务趋势接口
 *
 * @export
 * @tags 智能陪练首页接口
 * @link [GET] /intelligentPartner/homePage/admin/taskTrend
 */
export function getIntelligentPartnerHomePageAdminTaskTrend(
    options: ApiOptions<never, GetIntelligentPartnerHomePageAdminTaskTrendQuery> & {
        params: GetIntelligentPartnerHomePageAdminTaskTrendQuery;
    }
): Promise<BaseResponseListIntelligentPartnerHomePageAdminTaskTrend> {
    return request<never, never, GetIntelligentPartnerHomePageAdminTaskTrendQuery>(
        '/intelligentPartner/homePage/admin/taskTrend',
        {
            ...options,
            method: 'get',
            __$requestCalleeName: 'getIntelligentPartnerHomePageAdminTaskTrend',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练首页接口'],
        path: '/intelligentPartner/homePage/admin/taskTrend',
        method: 'get',
    },
];
